import SelectMenu from "../../../controls/SelectMenu";
import Input from "../../../controls/Input";
import ReportLotNumberLabel from "../ReportLotNumberLabel";

export default function ProductionDetailsFilter(props) {
  const { filters, setFilters, products } = props;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-3">
      <SelectMenu
        title="Product"
        handleInputChange={(e) =>
          setFilters({ ...filters, product: e.target.value })
        }
        name="product"
        options={products}
        value={filters.product}
      />
       <Input
              label={
                <ReportLotNumberLabel
                  report="productionDetail"
                  htmlFor="lot_number"
                />
              }
              name="lot_number"
              value={filters.lot_number}
              onChange={(e) => setFilters({ ...filters, lot_number: e.target.value })}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
    </div>
  );
}
